import React from 'react';
import { COLORS } from '../utils/uiStyles';

// 렌더 예외를 잡아 전체 흰화면 대신 한글 폴백 + 새로고침 제공.
export default class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { hasError: false }; }
  static getDerivedStateFromError() { return { hasError: true }; }
  componentDidCatch(error, info) { try { console.error('UI error:', error, info); } catch (e) { /* */ } }
  render() {
    if (this.state.hasError) {
      return (
        <div role="alert" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: 'var(--gw-app-h, 100dvh)', gap: '14px', fontFamily: 'var(--gw-font)', color: '#374151', padding: '32px 20px', textAlign: 'center', boxSizing: 'border-box', background: '#f8fafc' }}>
          <div style={{ width: '42px', height: '42px', borderRadius: '50%', background: COLORS.primarySoft, color: COLORS.selectedText, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '22px', fontWeight: 800 }}>!</div>
          <div style={{ fontSize: '20px', fontWeight: 800, lineHeight: 1.35 }}>일시적인 오류가 발생했습니다</div>
          <div style={{ maxWidth: '360px', fontSize: '14px', color: '#6b7280', lineHeight: 1.6 }}>화면을 표시하는 중 문제가 발생했습니다.<br />새로고침 후 다시 시도해 주십시오.</div>
          <button onClick={() => window.location.reload()} style={{ minWidth: '132px', minHeight: '42px', padding: '10px 20px', background: COLORS.primary, color: '#fff', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: 700, cursor: 'pointer', boxShadow: '0 8px 20px rgba(15,23,42,.12)' }}>새로고침</button>
        </div>
      );
    }
    return this.props.children;
  }
}
